export default __webpack_public_path__ + "static/media/menu-payment-links.c80c8515.svg";